/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Icd10Code } from './Icd10Code';
import {
    Icd10CodeFromJSON,
    Icd10CodeFromJSONTyped,
    Icd10CodeToJSON,
    Icd10CodeToJSONTyped,
} from './Icd10Code';

/**
 * 
 * @export
 * @interface FindAllIcd10CodesResponse
 */
export interface FindAllIcd10CodesResponse {
    /**
     * 
     */
    data: Array<Icd10Code>;
    /**
     * 
     */
    total: number;
    /**
     * 
     */
    page: number;
    /**
     * 
     */
    limit: number;
    /**
     * 
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the FindAllIcd10CodesResponse interface.
 */
export function instanceOfFindAllIcd10CodesResponse(value: object): value is FindAllIcd10CodesResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('limit' in value) || value['limit'] === undefined) return false;
    if (!('has_next' in value) || value['has_next'] === undefined) return false;
    return true;
}

export function FindAllIcd10CodesResponseFromJSON(json: any): FindAllIcd10CodesResponse {
    return FindAllIcd10CodesResponseFromJSONTyped(json, false);
}

export function FindAllIcd10CodesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllIcd10CodesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(Icd10CodeFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'limit': json['limit'],
        'has_next': json['has_next'],
    };
}

export function FindAllIcd10CodesResponseToJSON(json: any): FindAllIcd10CodesResponse {
    return FindAllIcd10CodesResponseToJSONTyped(json, false);
}

export function FindAllIcd10CodesResponseToJSONTyped(value?: FindAllIcd10CodesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(Icd10CodeToJSON)),
        'total': value['total'],
        'page': value['page'],
        'limit': value['limit'],
        'has_next': value['has_next'],
    };
}

